import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';

import { AuthService } from '@oneComply/core/services/auth.service';

export const authGuard: CanActivateFn = (_route, state) => {
  const authService = inject(AuthService);

  if (authService.getToken()) {
    return true;
  }

  const intendedPath = state.url.startsWith('/auth/callback') ? '/dashboard' : state.url;
  authService.redirectToLogin(intendedPath);

  return false;
};

